import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import Logo from '../assets/images//logo-w.png';
import { useFormik } from 'formik';

import upi from '../assets/images/upi.png';
import Rupay from '../assets/images/Rupay.png';
import viza from '../assets/images/viza.png';
import master from '../assets/images/master.png';


import { get_common, newsLaters } from '../apiservices/ApiServices';
import { FaFacebookF, FaInstagram, FaYoutube, FaTwitter, FaLinkedinIn, FaShieldHalved, FaCodeBranch } from "react-icons/fa6";
import { FaPhoneAlt, FaMapMarkerAlt, FaEnvelope, } from "react-icons/fa";

import WhatsApp from '../assets/images/WhatsApp.png';
import { Container } from 'react-bootstrap';
const initialValues = {
    email: '',
};
const Footer = (props) => {
    const [isLoading, setLoading] = useState(true);
    const [isLoadings, setLoadings] = useState(false);
    const [data, setData] = useState([]);

    useEffect(() => {
        get_common().then((res) => {
            try {
                setData(res.data.data);
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        });

    }, [])

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: '',
        enableReinitialize: true,
        onSubmit: async (values) => {
            setLoadings(true);

            let postData = {
                email: values.email
            }

            try {
                const res = await newsLaters(postData);
                //props.toast.success(res.data.message);
            } catch (error) {
                props.toast.error(error?.response?.data?.message || 'Something went wrong');
            } finally {
                setLoadings(false);
            }
        },
    });
    const { values, handleChange, handleBlur, handleSubmit, setFieldValue } = formik;

    return (
        <>
            <section className="news">
                <div className="wrap">
                    <span className="env reveal">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
                            strokeLinecap="round" strokeLinejoin="round">
                            <rect x="2" y="4" width="20" height="16" rx="2" />
                            <path d="M2 6l10 7 10-7" />
                        </svg>
                    </span>
                    <div className="txt reveal d1">
                        <h3>STAY PROTECTED. STAY UPDATED.</h3>
                        <p>Get the latest offers, new launches &amp; exclusive deals.</p>
                    </div>
                    <div className="form reveal d2">
                        <input
                            type="email"
                            name="email"
                            value={values.email}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            placeholder="Enter your email address"
                        />
                        <button type="submit" onClick={handleSubmit} className="buttons">SUBSCRIBE</button>
                    </div>
                </div>
            </section>

            <footer className="footer">
                <div className="wrap">
                    <div className="foot-top">
                        <div className="foot-brand">
                            <div className="logobox">
                                <Link to={'/'}>
                                    <img src={Logo} alt='logo' title='logo' />
                                </Link>
                            </div>
                            <p>India's premium mobile accessories brand. Tough protection. Premium quality. Built for real life.</p>
                            <div className="socials">
                                {data?.company_details?.facebook_link != '' && (<Link target='_blank' to={data?.company_details?.facebook_link}><FaFacebookF /></Link>)}
                                {data?.company_details?.instagram_link != '' && (<Link target='_blank' to={data?.company_details?.instagram_link}><FaInstagram /></Link>)}
                                {data?.company_details?.linkedin_link != '' && (<Link target='_blank' to={data?.company_details?.linkedin_link}><FaLinkedinIn /></Link>)}
                                {data?.company_details?.youtube_link != '' && (<Link target='_blank' to={data?.company_details?.youtube_link}><FaYoutube /></Link>)}
                                {data?.company_details?.twitter_link != '' && (<Link target='_blank' to={data?.company_details?.twitter_link}><FaTwitter /></Link>)}
                            </div>

                            <div className='contactus-box'>
                                <ul>
                                    <li className='icons'><FaPhoneAlt /></li>
                                    <li><p><Link to={`tel:${data?.company_details?.phone_number}`}>{data?.company_details?.phone_number}</Link></p></li>
                                </ul>
                                <ul>
                                    <li className='icons'><FaEnvelope /></li>
                                    <li><p><Link to={`mailto:${data?.company_details?.email}`}>{data?.company_details?.email}</Link></p></li>
                                </ul>
                                <ul>
                                    <li className='icons'><FaMapMarkerAlt /></li>
                                    <li><p><Link to={data?.company_details?.map_address} dangerouslySetInnerHTML={{ __html: data?.company_details?.address }} /></p></li>
                                </ul>
                            </div>
                        </div>
                        <div className="fcol">
                            <h5 style={{ textTransform: 'uppercase' }}>categories</h5>
                            {!isLoading &&
                                <>
                                    {data.category_list.map((item, index) => {
                                        return (
                                            <Link key={item.id} to={item.childs?.length > 0 ? `/categorie/${item.slug}` : `/product/categories/${item.slug}`}>{item.name.toLowerCase()}</Link>
                                        );

                                    })}
                                </>
                            }
                        </div>
                        <div className="fcol">
                            <h5>COMPANY</h5>
                            {!isLoading &&
                                <>
                                    <Link to={'/find-your-model'}>Find Your Model</Link>
                                    <Link to={'/about-us'}>About Us</Link>
                                    {data?.policy_list.map((item) => {
                                        return (
                                            <>
                                                {item.slug == 'about-us' ? '' : <Link key={item.id} to={`/policys/${item.slug}`}>{item.title}</Link>}
                                            </>
                                        );
                                    })}
                                </>
                            }
                        </div>
                        <div className="pay">
                            <h5>SECURE PAYMENTS</h5>
                            <div className="payrows">
                                <ul>
                                    <li><img src={upi} alt='upi' title='upi' /></li>
                                    <li><img src={Rupay} alt='Rupay Card' title='Rupay Card' /></li>
                                    <li><img src={viza} alt='viza Card' title='viza Card' /></li>
                                    <li><img src={master} alt='Rupay Card' title='Master Card' /></li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className='footerBottomBox'>
                        <Container>
                            <div className="hero-perks">
                                <div className="hero-perk"><FaShieldHalved /><span><b>1-Year Warranty</b>on Premium Products</span></div>
                                <div className="hero-perk"><FaCodeBranch /><span><b>2 Free Replacements</b>on Premium Shield</span></div>
                                <div className="hero-perk"><FaShieldHalved /><span><b>Secure Checkout</b>100% Safe &amp; Trusted</span></div>
                            </div>
                        </Container>
                    </div>

                </div>
                <div className="foot-bottom">&copy; 2026 Mobistorm. All rights reserved.</div>


                <div className='whatsAppIo'>
                    <a
                        href={`https://wa.me/${918291522522}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        title="Chat on WhatsApp"
                    >
                        <img src={WhatsApp} alt="WhatsApp" title="WhatsApp" />
                    </a>
                </div>
            </footer>
        </>
    )
}
export default Footer